import { combineReducers } from "redux";
import groups from "./groupsReducer";
import products from "./productsReducer";
import featuredProducts from "./featuredProductsReducer";
import relatedProducts from "./relatedProductsReducer";
import recommendedProducts from "./recommendedProductsReducer";
import selectedProduct from "./selectedProductReducer";
import promotions from "./promotionsReducer";
import sliderItems from "./sliderItemsReducer";
import cart from "./cartReducer";
import carts from "./cartsReducer";
import orderResponse from "./orderResponseReducer";
import checkoutSale from "./checkoutSaleReducer";
import selectedOrder from "./selectedOrderReducer";
import orders from "./ordersReducer";
import wishlist from "./wishlistReducer";
import { reducer as formReducer } from "redux-form";
import pager from "./pagerReducer";
import settings from "./settingsReducer";
import siteLinks from "./siteLinksReducer";
import openpayPlan from "./openpayPlanReducer";
import user from "./userReducer";
import page from "./pageReducer";
import error from "./errorReducer";
import locale from "./localeReducer";
import referrals from "./referralsReducer"
import consultant from "./consultantReducer"

//import checkoutOrder from "./checkoutOrderReducer";
import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";
import { loadingBarReducer as loadingBar } from "react-redux-loading-bar";
import showLoader from "./showLoaderReducer";

const appReducer = combineReducers({
    groups,
    products,
    featuredProducts,
    relatedProducts,
    recommendedProducts,
    promotions,
    sliderItems,
    selectedProduct,
    cart,
    carts,
    wishlist,
    pager,
    settings,
    siteLinks,
    user,
    page,
    orderResponse,
    orders,
    error,
    loadingBar,
    form: formReducer,
    selectedOrder,
    checkoutSale, // holds the initial customer sale at the checkout and information from checkoutscreen after the user submits the order
    locale,
    openpayPlan,
    showLoader,
    referrals,
    consultant
   // translations
    //checkoutOrder
})

const rootReducer = (state, action) => {
    if (action.type === ActionTypes.LOGOUT) {
        state = initialState
    }

    return appReducer(state, action)
}


export default rootReducer;
